export default __webpack_public_path__ + "static/media/average_speeds_icon.f73f9941.png";